<div class="modal-header">
  <h5 class="modal-title">Cadastro de Operador</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="dismiss()"
  ></button>
</div>

<div class="modal-body" [formGroup]="form">
  <div class="mb-3">
    <div class="row align-items-end g-2">
      <div class="col-md-8">
        <label class="form-label">Buscar por CNPJ (Pré-cadastro)</label>
        <div class="input-icon-container">
          <input
            type="text"
            class="form-control pe-5"
            [formControl]="preCnpj"
            placeholder="Digite o CNPJ"
            mask="CPF_CNPJ"
            (keyup.enter)="buscarPreAccount()"
          />
          <i
            class="fe fe-clipboard input-icon cursor-pointer btn-color"
            placement="top"
            ngbTooltip="Colar"
            (click)="pasteDocument()"
          ></i>
        </div>
      </div>

      <div class="col-md-4">
        <button
          type="button"
          class="btn btn-pill btn-primary w-100"
          (click)="buscarPreAccount()"
          [disabled]="isSearchingPre"
        >
          <i class="fe fe-search me-2"></i>Buscar
        </button>
      </div>
    </div>
  </div>

  <mat-accordion [multi]="false">
    <mat-expansion-panel
      [expanded]="isProjectExpanded"
      (opened)="openSection('project')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Dados do Projeto</mat-panel-title>
      </mat-expansion-panel-header>

      <div formGroupName="operatorRegistration">
        <div class="row g-2 project-row">
          <div class="col-md-6">
            <div class="form-group mb-0">
              <label class="form-label">Percentual GGR</label>
              <input
                type="number"
                class="form-control"
                formControlName="percentGGR"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-0">
              <label class="form-label">Nome do Projeto</label>
              <input
                type="text"
                class="form-control"
                formControlName="nameProject"
              />
            </div>
          </div>
        </div>

        <div class="row g-2 project-row">
          <div class="col-md-6">
            <div class="form-group mb-0">
              <label class="form-label">Site</label>
              <input type="text" class="form-control" formControlName="site" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-0">
              <label class="form-label">Licenciamento</label>
              <ng-select
                class="modal-select"
                appendTo="body"
                [items]="licensingOptions"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [searchable]="false"
                [loading]="licensingsLoading"
                formControlName="licensingRegistrationId"
              ></ng-select>
            </div>
          </div>
        </div>

        <div class="row g-2">
          <div class="col-md-6">
            <div class="form-group mb-0">
              <label class="form-label">Banco</label>
              <ng-select
                class="modal-select"
                appendTo="body"
                [items]="bankOptions"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [searchable]="false"
                [loading]="banksLoading"
                formControlName="bankProvider"
              ></ng-select>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-0">
              <label class="form-label">Plataforma</label>
              <ng-select
                class="modal-select"
                appendTo="body"
                [items]="platformOptions"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [searchable]="false"
                [loading]="platformsLoading"
                formControlName="currentPlatform"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isCompanyExpanded"
      (opened)="openSection('company')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Empresa</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-2" formGroupName="company">
        <div class="col-md-4">
          <div class="form-group mb-0">
            <label class="form-label">CNPJ</label>
            <input
              type="text"
              class="form-control"
              formControlName="cnpj"
              mask="CPF_CNPJ"
            />
          </div>
        </div>

        <div class="col-md-8">
          <div class="form-group mb-0">
            <label class="form-label">Razão Social</label>
            <input
              type="text"
              class="form-control"
              formControlName="razaoSocial"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-0">
            <label class="form-label">Email</label>
            <input type="text" class="form-control" formControlName="email" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-0">
            <label class="form-label">Telefone</label>
            <input type="text" class="form-control" formControlName="phone" />
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isAddressExpanded"
      (opened)="openSection('address')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Endereço</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-2" formGroupName="adress">
        <div class="col-md-6">
          <div class="form-group mb-0">
            <label class="form-label">Logradouro</label>
            <input
              type="text"
              class="form-control"
              formControlName="logradouro"
            />
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group mb-0">
            <label class="form-label">Número</label>
            <input type="text" class="form-control" formControlName="numero" />
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group mb-0">
            <label class="form-label">Complemento</label>
            <input
              type="text"
              class="form-control"
              formControlName="complemento"
            />
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group mb-0">
            <label class="form-label">CEP</label>
            <input type="text" class="form-control" formControlName="cep" />
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group mb-0">
            <label class="form-label">Bairro</label>
            <input type="text" class="form-control" formControlName="bairro" />
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group mb-0">
            <label class="form-label">Cidade</label>
            <input type="text" class="form-control" formControlName="cidade" />
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group mb-0">
            <label class="form-label">Estado</label>
            <select
              class="form-select"
              formControlName="estado"
            >
              <option value="">Selecione</option>
              <option *ngFor="let estado of estados" [value]="estado">
                {{ estado }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isSponsorExpanded"
      (opened)="openSection('sponsor')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Responsável</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-2" formGroupName="sponsor">
        <div class="col-md-4">
          <div class="form-group mb-0">
            <label class="form-label">CPF</label>
            <input
              type="text"
              class="form-control"
              formControlName="cpf"
              mask="CPF_CNPJ"
            />
          </div>
        </div>

        <div class="col-md-8">
          <div class="form-group mb-0">
            <label class="form-label">Nome</label>
            <input type="text" class="form-control" formControlName="name" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-0">
            <label class="form-label">Email</label>
            <input type="text" class="form-control" formControlName="email" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mb-0">
            <label class="form-label">Telefone</label>
            <input type="text" class="form-control" formControlName="phone" />
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isPermissionsExpanded"
      (opened)="openSection('permissions')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Permissões</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label d-block"
            >Bloquear Depósito de Terceiro</label
          >
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              formControlName="featureFlagRefundPix"
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Bloquear Saque para Terceiro</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              formControlName="featureFlagCpfWithdraw"
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Exibir Três Decimais</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              formControlName="featureFlagNewParam"
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isListCnpjExpanded"
      (opened)="openSection('listCnpj')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Lista CNPJ</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3" formGroupName="listCnpj">
        <div class="col-md-6">
          <label class="form-label d-block">Bloquear Depósito via CNPJ</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              formControlName="flagCnpjCashIn"
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-6">
          <label class="form-label d-block">Bloquear Saque via CNPJ</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              formControlName="flagCnpjCashOut"
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Lista de Cnpj Autorizados - Depósito</mat-label>

            <mat-chip-grid
              #chipGridIn
              aria-label="Lista de Cnpj Autorizados - Depósito"
            >
              <mat-chip-row
                *ngFor="
                  let c of form.controls.listCnpj.controls.cnpjCashIn.value ??
                    []
                "
                (removed)="removeCnpj(c, 'in')"
              >
                {{ c }}
                <button matChipRemove type="button" aria-label="Remover CNPJ">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>

              <input
                matInput
                placeholder="Lista de Cnpj Autorizados - Depósito"
                [matChipInputFor]="chipGridIn"
                [matChipInputSeparatorKeyCodes]="separatorKeys"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addCnpj($event, 'in')"
              />
            </mat-chip-grid>
          </mat-form-field>
        </div>

        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Lista de Cnpj Autorizados - Saque</mat-label>

            <mat-chip-grid
              #chipGridOut
              aria-label="Lista de Cnpj Autorizados - Saque"
            >
              <mat-chip-row
                *ngFor="
                  let c of form.controls.listCnpj.controls.cnpjCashOut.value ??
                    []
                "
                (removed)="removeCnpj(c, 'out')"
              >
                {{ c }}
                <button matChipRemove type="button" aria-label="Remover CNPJ">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>

              <input
                matInput
                placeholder="Lista de Cnpj Autorizados - Saque"
                [matChipInputFor]="chipGridOut"
                [matChipInputSeparatorKeyCodes]="separatorKeys"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addCnpj($event, 'out')"
              />
            </mat-chip-grid>
          </mat-form-field>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isIpExpanded"
      (opened)="openSection('ip')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Liberação de IP</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Lista de IPs Autorizados</mat-label>

            <mat-chip-grid #chipGridIp aria-label="Lista de IPs Autorizados">
              <mat-chip-row
                *ngFor="let ip of form.controls.listsIp.value ?? []"
                (removed)="removeIp(ip)"
              >
                {{ ip }}
                <button matChipRemove type="button" aria-label="Remover IP">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>

              <input
                matInput
                placeholder="Digite o IP"
                [matChipInputFor]="chipGridIp"
                [matChipInputSeparatorKeyCodes]="separatorKeys"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addIp($event)"
              />
            </mat-chip-grid>
          </mat-form-field>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary btn-pill"
    (click)="save()"
    [disabled]="isSaving || validatingPassword || form.invalid"
  >
    Salvar
  </button>
</div>

<ng-template #requestPasswordInsert let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe a senha</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage && errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>

    <div class="form-group mb-3">
      <input
        type="password"
        class="form-control"
        placeholder="Senha"
        [(ngModel)]="passwordInsert"
        [ngModelOptions]="{ standalone: true }"
        (keyup.enter)="confirmPasswordInsert()"
      />
    </div>
  </div>

  <div class="modal-footer text-center">
    <button
      type="button"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="confirmPasswordInsert()"
      [disabled]="validatingPassword || isSaving"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
